import type { HealthFeatureConfig } from '../../../types/insurances/HealthFeatureConfig';

export const health: HealthFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showContractNumber: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
            showCard: false,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
